import { FormEvent, useState } from "react";
import { Modal, Form, FormGroup, Input, Button } from "reactstrap";
import TemplateAPI from "../../../api/api/TemplateAPI";
import AppSpinner from "../../../elements/AppSpinner";
import RightArrow from "../../../elements/RightArrow";
import { newToastEvent } from "../../../utils/ToastUtil";

interface Props {
  open: boolean;
  onClose: () => void;
  cloud: any;
}

const CloudTemplateModal = ({ open, onClose, cloud }: Props) => {
  const [templateName, setTemplateName] = useState("");
  const [templateDescription, setTemplateDescription] = useState("");
  const [submitting, setSubmitting] = useState(false);

  return (
    <Modal className="modal-dialog-centered" isOpen={open} toggle={onClose}>
      <div className="modal-header">
        <h5 className="modal-title" id="exampleModalLabel">
          Create Template From Cloud
        </h5>
        <button
          aria-label="Close"
          className="close"
          data-dismiss="modal"
          type="button"
          onClick={onClose}
        >
          <span aria-hidden={true}>×</span>
        </button>
      </div>
      <Form onSubmit={createTemplateFromCloud}>
        <div className="modal-body">
          <FormGroup>
            <h5>Template Name</h5>
            <Input
              placeholder="Name"
              value={templateName}
              onChange={(e) => setTemplateName(e.target.value)}
            ></Input>
          </FormGroup>
          <FormGroup>
            <h5>Template Description</h5>
            <Input
              placeholder="Description"
              type="textarea"
              name="templateDescription"
              value={templateDescription}
              onChange={(e) => setTemplateDescription(e.target.value)}
            ></Input>
          </FormGroup>
        </div>
        <div className="modal-footer">
          <Button
            color="secondary"
            data-dismiss="modal"
            type="button"
            onClick={onClose}
          >
            Close
          </Button>
          <Button
            color="primary"
            type="submit"
            disabled={!templateName || submitting}
          >
            {submitting ? (
              <AppSpinner style={{ height: 20, width: 20 }} color="white" />
            ) : (
              <>Create</>
            )}
          </Button>
        </div>
      </Form>
    </Modal>
  );

  function createTemplateFromCloud(e: FormEvent) {
    e.preventDefault();

    setSubmitting(true);

    TemplateAPI.createTemplateFromCloudTenant(
      cloud.id,
      templateName,
      templateDescription
    )
      .then(
        (data) => {
          onClose();
          newToastEvent(
            "success",
            <>
              Successfully created template from cloud.{" "}
              <a
                href={`/supportal/global/templates/${data.data.data.template.id}`}
              >
                View Template <RightArrow />
              </a>
            </>
          );
        },
        (e) => {
          console.error(e);
          newToastEvent(
            "error",
            e?.response?.data?.message
              ? e?.response?.data?.message
              : "Failed to create template. Try again."
          );
        }
      )
      .finally(() => setSubmitting(false));
  }
};

export default CloudTemplateModal;
